import { middleSidePartOfDoubleWeb, topSidePartOfWeb } from './parts/sideParts'
import { verticalPartsOfWeb } from './parts/verticalParts'

export const crossDoubleWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ_縦
  verticalPartsOfWeb(ctx, webColor, stitchColor)
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // ウェブ_横＿中間
  middleSidePartOfDoubleWeb(ctx, webColor, stitchColor)
}

export const crossDoubleWebWithEdge = (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  edgeColor: string,
  laceColor: string,
  stitchColor: string
): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ_縦
  verticalPartsOfWebWithEdge(ctx, webColor, edgeColor, stitchColor)
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // ウェブ_横＿中間
  middleSidePartOfDoubleWeb(ctx, webColor, stitchColor)
}

const verticalPartsOfWebWithEdge = (ctx: CanvasRenderingContext2D, webColor: string, edgeColor: string, stitchColor: string): void => {
  // ウェブ_縦
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(250, 212) // 左＿上
  ctx.quadraticCurveTo(273, 285, 314, 355) // 左＿下
  ctx.quadraticCurveTo(322, 355, 342, 307) // 右＿下
  ctx.quadraticCurveTo(313, 241, 293, 150) // 右＿上
  ctx.quadraticCurveTo(265, 189, 251, 212) // 左＿上
  ctx.fill()
  ctx.closePath()
  // ヘリ革左ここから
  ctx.fillStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(250, 212) // 上＿外
  ctx.quadraticCurveTo(273, 285, 313, 355) // 左＿下
  ctx.quadraticCurveTo(316, 353, 317, 348) // 下＿内
  ctx.quadraticCurveTo(275, 267, 257, 205) // 上＿内
  ctx.quadraticCurveTo(250, 212, 250, 212) // 上＿外
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // ヘリ革右ここから
  ctx.beginPath()
  ctx.moveTo(287, 163) // 上＿内
  ctx.quadraticCurveTo(301, 229, 338, 315) // 下＿内
  ctx.quadraticCurveTo(342, 305, 342, 305) // 右＿下
  ctx.quadraticCurveTo(313, 241, 293, 150) // 上＿外
  ctx.quadraticCurveTo(287, 163, 287, 163) // 上＿内
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // ヘリ革ここまで

  // stitchここから
  ctx.lineWidth = 1.1
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 縦＿左
  ctx.moveTo(259, 203) // 右上
  ctx.quadraticCurveTo(283, 276, 317, 343) // 左下
  // 縦＿右
  ctx.moveTo(284, 166) // 右上
  ctx.quadraticCurveTo(304, 243, 334, 314) // 左下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = '#282828'
  ctx.closePath()
}
